import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';

declare var $: any;
import { IEpBtCardControlModel, BistrackConfig, LocalStorageSaveTypes, PageNames } from 'ep-bt-controls';

import { ActivatedRoute } from '@angular/router';
import { IEpCardModel } from '@epicor/kinetic';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { PagingParameters, SortParameters } from 'ep-bt-field-agent-proxy';
import { EpDataViewModelService } from '@epicor/kinetic';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { Location } from '@angular/common';
import { IEpGridModel, IEpGridSelectionOptions, IEpGridColumn, IEpGridEditState, EpGridEditMode, EpGridComponent, IEpComponentEventArg } from '@epicor/kinetic';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-related-grid',
  templateUrl: './epbt-fa-product-related-grid.component.html',
  styleUrls: ['./epbt-fa-product-related-grid.component.scss']
})
export class EpbtFaProductRelatedGridComponent implements OnInit {

  products: any;
  productsCode: any;
  data: any;
  productId: number;
  productDetails: any;
  productCode: any;
  productspurchased: any;
  bisTrackUserHasReadAccessToTheseBranches: any = [];
  pageNames = PageNames;
  @ViewChild(EpGridComponent, {static: false}) grid: EpGridComponent;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 10;
  public cards: Array<IEpBtCardControlModel>;
  bistrackSettings: any;
  currency: string;
  webTrackUser: any;
  branchId: number;
  customerId: number;
  searchstring: any;
  quantityFlag = false;

  productList: any = [];

  constructor(private client: FieldAgentClient, public productService: EpbtFaProductService,
    private route: ActivatedRoute, private router: Router,
    private fieldAgentService: EpbtFieldAgentService,
    private config: BistrackConfig, private location: Location, public quickOrderService: EpbtFaQuickOrderService) { }

  ngOnInit() {

    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = this.bistrackSettings.baseCurrency.symbol;
    });

    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.branchId = this.webTrackUser.webTrackTradingBranch.branchID;
      this.bisTrackUserHasReadAccessToTheseBranches = this.webTrackUser.bisTrackUserHasReadAccessToTheseBranches;
      this.customerId = this.webTrackUser.customer.customerId;
      this.pageSize = 100;
      this.gridModel = this.getGridModel();
      this.productDetails = this.productService.selectedProductItem;
      this.productId = this.productDetails.productId;
      this.getGridData();
    });
    console.log(this.productService.fromPage == PageNames.QuickOrderTalliedProductLineNegotiation || PageNames.QuickOrderMOLTNegotiation ||
      PageNames.QuickOrderLineNegotiation, 'QuickOrderTalliedProductLineNegotiation');
    // this.productDetails = this.productService.selectedProductItem;
    // this.productId = this.productDetails.productId;
  }



  // grid model start
  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productCode',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      editable: true,
      editOptions: {
        defaultEditable: true,
        editMode: EpGridEditMode.cell,
        updateOnChange: true,
        // validation on change of value
        onChangeValidate: (column: IEpGridColumn, newValue: any, originalValue: any, state: IEpGridEditState) => {
          if (column.field === 'quantity' && newValue < 0) {
            return false;
          }
          if (column.field === 'quantity' && (newValue % 1) > 0) {
            return false;
          }
          this.quickOrderService.selectedRelatedproduct = this.productList;
          return true;
        }
      },


      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      // data: this.gridModel.data,
      columns: [
        { field: 'product.description', title: 'PRODUCT DESCRIPTION', width: 100, hidden: false, editable: false },
        { field: 'product.productCode', title: 'PRODUCT CODE', width: 80, hidden: false, editable: false },
        { field: 'quantity', title: 'QUANTITY', width: 60,
          hidden: !((this.productService.fromPage == PageNames.QuickOrderTalliedProductLineNegotiation) ||
          (this.productService.fromPage == PageNames.QuickOrderMOLTNegotiation) || (this.productService.fromPage == PageNames.QuickOrderLineNegotiation)),
          class: 'color-blue', editable: true, editor: 'numeric'
        },
        { field: 'uom', title: 'UOM', width: 40,
          hidden: !((this.productService.fromPage == PageNames.QuickOrderTalliedProductLineNegotiation) ||
          (this.productService.fromPage == PageNames.QuickOrderMOLTNegotiation) || (this.productService.fromPage == PageNames.QuickOrderLineNegotiation)),
          editable: false
        }
      ],
      // epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
      //   if (eventArg.eventId == 'epOnCellClick') {
      //     this.navigateToProductDetailsView(eventArg.event.dataItem.product);
      //   }
      // },
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          if (!((this.productService.fromPage == PageNames.QuickOrderTalliedProductLineNegotiation) ||
          (this.productService.fromPage == PageNames.QuickOrderMOLTNegotiation) || (this.productService.fromPage == PageNames.QuickOrderLineNegotiation))) {
            this.navigateToProductDetailsView(eventArg.event.dataItem.product);
          }
        }
      },
      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick) {
      //     this.navigateToProductDetailsView(args.dataItem);
      //   }
      // },
    };
    return model;
  }
  // grid model end

  // grid height calculation start
  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 440; }// return 500;
  }
  // grid height calculation end
  // api call start

  getGridData() {

    this.client.getRelatedProductsList(this.productId).subscribe(res => {
      this.productspurchased = res;
      res.forEach(data => {
        const productModel: any = {
          product: data,
          quantity: 0,
          uom: data.sellPer ? data.sellPer.perCode : ''
        };
        this.productList.push(productModel);
      });

      this.gridModel.data = this.productList;
      this.quickOrderService.selectedRelatedproduct = this.productList;
    });
  }

  // api call end
  // row click start

  navigateToProductDetailsView(args) {
    this.searchstring = args.productCode;
    this.productService.getProductListGridData(
      this.searchstring, this.branchId, this.webTrackUser.bisTrackUserHasReadAccessToTheseBranches, this.bistrackSettings.searchMOLTsInProductFindInOrderEntry,
      this.customerId, this.pageSize, 0, (res: any) => {
      if (res != null) {
        this.products = res.lines;
        const result = this.products.filter(x => x.productId == args.productId);
        if (result) {
          this.productService.selectedProductItem = result[0];
        }
        localStorage.setItem(LocalStorageSaveTypes.ProIndex, '0');
        this.router.navigate(['/home/product/details', args.productId]);
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
          return false;
        };
      }
    });
  }

  onCardClick(model) {
    if (!((this.productService.fromPage == PageNames.QuickOrderTalliedProductLineNegotiation) ||
      (this.productService.fromPage == PageNames.QuickOrderMOLTNegotiation) ||
      (this.productService.fromPage == PageNames.QuickOrderLineNegotiation))) {

      this.navigateToProductDetailsView(model);
    }
  }
  // row click end
  onQuantityChange() {
    this.quickOrderService.selectedRelatedproduct = this.productList;
  }

}
